<script setup>
import Button from '@components/global/button.vue'
defineProps(['product'])
</script>

<template>
	<Button :to="{ name: 'product', params: { slug: product.slug } }" :content="true" class="group animation relative w-full overflow-hidden rounded-[16px] bg-bg-dark outline outline-1 outline-offset-[-1px] outline-sf-purple-base hover:bg-bg-base hover:outline-dashed hover:outline-2">
		<div class="relative flex w-full items-center gap-2 overflow-hidden">
			<div class="relative flex h-full flex-1 flex-col items-start">
				<div class="relative flex w-full flex-col items-start gap-1 p-6">
					<div class="w-full font-body text-h6 font-medium text-text-muted/50">
						<p class="leading-[1.2]">{{ product.type }}</p>
					</div>
					<div class="animation line-clamp-2 h-[48px] group-hover:text-sf-purple-base">
						<h6 class="font-semibold md:text-h5">{{ product.name }}</h6>
					</div>
				</div>
				<div class="relative w-full flex-1 p-1">
					<div class="overflow-hidden w-full rounded-[16px]">
						<img alt="Product image" class="animation aspect-square w-full object-contain group-hover:scale-105" :src="product.images?.at(0)?.url" />
					</div>
				</div>
			</div>
		</div>
	</Button>
</template>
